"use client";

import { useAuthStore, useAuthRedirect, useVerificationRedirect } from "@/hooks";
import { useLocale } from "@/i18n";
import { withLocale } from "@/helpers";

/**
 * ProtectedPage — auth + verification gates (subscription/billing checks are out of scope).
 * API auth middleware remains the source of truth for access.
 */
interface ProtectedPageProps {
  children: React.ReactNode;
  redirectTo?: string;
  requiredRoles?: string[];
}

const ProtectedPage = ({
  children,
  redirectTo,
}: ProtectedPageProps) => {
  const locale = useLocale();
  const { isAuthenticated, user } = useAuthStore();

  useAuthRedirect({
    redirectTo: redirectTo || withLocale(locale, "/login"),
  });

  const { redirectAvailable: verificationRedirectAvailable } =
    useVerificationRedirect();

  if (verificationRedirectAvailable) {
    return null;
  }

  if (!isAuthenticated || !user) {
    return null;
  }

  return children;
};

export { ProtectedPage };
